const ACTION_POINT_INFO = Symbol('actionPointInfo');
const EDITOR = Symbol('editor');
const STOP_ACTION = Symbol('stopAction');
const UI_CONFIG = Symbol('uiConfig');
const WORKBENCH_CUSTOM_ARGS = Symbol('workbenchCustomMetadata');
const ACTION_POINT_PARAM = Symbol('actionPointParam');
const ACTION_POINT_VALUE = Symbol('actionPointValue');
const ACTION_POINT_EVENT = Symbol('actionPointEvent');

export { ACTION_POINT_EVENT, ACTION_POINT_INFO, ACTION_POINT_PARAM, ACTION_POINT_VALUE, EDITOR, STOP_ACTION, UI_CONFIG, WORKBENCH_CUSTOM_ARGS };
//# sourceMappingURL=registry-keys.js.map
